<script lang="ts" setup>
import { ListItemModel } from '../../../models';
import { computed, PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import { UserCircleIcon } from 'tir-style-system/icons/outline';
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmIconView,
  TirPmPopover,
  TirPmScrollbar,
  TirPmTooltipElement,
} from 'tir-components';
import { TaskModel, TaskPersonModel } from '../../../../../pages/monitorings/models';

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
  /**Таблица мониторинга тикетов */
  monitoringTicketPage: { type: Boolean, default: false },
  /**Отображать исполнителей в левой части таблицы */
  isPerformersLeftBlock: { type: Boolean, default: false },
  /**Скрыть правый блок с исполнителями */
  hiddenPersonsRightBlock: { type: Boolean, default: false },
});

/**Кол-во срезаемых элементов */
const countSlicePersons = props.hiddenPersonsRightBlock ? 4 : 2;
/**Показанные исполнители */
const shownPersons = computed<TaskPersonModel[]>(() => {
  const persons = props.task.Performers.slice(0, countSlicePersons);
  const uniqueIds = Array.from(new Set(persons.map((p) => p.Id)));
  const personsToShow = [];
  uniqueIds.forEach((id) => {
    personsToShow.push(persons.find((p) => p.Id == id));
  });
  return personsToShow;
});
/**Скрытые исполнители */
const hiddenPersons = computed<TaskPersonModel[]>(() =>
  props.task.Performers.slice(countSlicePersons),
);
</script>
<template>
  <TaskCardItemWrapper
    v-if="!isPerformersLeftBlock"
    :element="element"
    :class="{ 'task-card_block': monitoringTicketPage }"
  >
    <template v-if="props.task.Performers.length > 0">
      <UserCircleIcon v-if="isPerformersLeftBlock" class="task-card_icon" />
      <TirPmTooltipElement v-for="person in shownPersons" :key="person.Id">
        <template #default>
          <TirPmIconView
            is-rounded
            :size="24"
            :imageLoadUrl="person.ImageUrl"
            :colorCode="person.NoPhotoColor"
            :is-bordered="false"
          >
            <template #mainSlot>
              {{ person.FirstName[0] + person.LastName[0] }}
            </template>
          </TirPmIconView>
        </template>
        <template #content>
          <div class="task-card_user-data">
            {{ person.LastName }} {{ person.FirstName }} {{ person.MiddleName }}
          </div>
        </template>
      </TirPmTooltipElement>

      <div class="task-card_hidden-users">
        <TirPmPopover :isHideTriangle="false" @click.stop.prevent>
          <template #default>
            <div
              v-if="hiddenPersons.length > 0"
              v-text="`+${hiddenPersons.length}`"
              class="task-card_circle"
            />
          </template>
          <template #content>
            <TirPmScrollbar class="task-card_scrollbar" :show-on-hover="true">
              <div
                v-for="person in hiddenPersons"
                :key="person.Id"
                class="task-card_hidden-users-content"
              >
                <TirPmIconView
                  is-rounded
                  :size="24"
                  :imageLoadUrl="person.ImageUrl"
                  :colorCode="person.NoPhotoColor"
                  :is-bordered="false"
                >
                  <template #mainSlot>
                    {{ person.FirstName[0] + person.LastName[0] }}
                  </template>
                </TirPmIconView>
                {{ person.LastName }} {{ person.FirstName }} {{ person.MiddleName }}
              </div>
            </TirPmScrollbar>
          </template>
        </TirPmPopover>
      </div>
    </template>
    <div v-else class="task-card_absence-elements">-</div>
  </TaskCardItemWrapper>
</template>
<style lang="scss" scoped>
.task-card {
  &_block {
    display: flex;
    justify-content: end !important;
  }

  &_scrollbar {
    max-height: 15rem;
  }

  &_absence-elements {
    font-size: 1.5625rem;
  }

  &_hidden-users-content {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
  }

  &_circle {
    cursor: pointer;
  }

  &_user-data {
    display: flex;
    justify-content: center;
    overflow-wrap: break-word;
    padding: 1rem;
  }
}
</style>
